import type { Node } from "prosemirror-model";
import { Plugin, TextSelection } from "prosemirror-state";

import { schema } from "../adapter/schema";
import { mergeAdjacentCodeBlocks } from "../utils";

function hasAdjacentCodeBlocks(doc: Node): boolean {
  for (let i = 1; i < doc.childCount; i += 1) {
    if (
      doc.child(i).type === schema.nodes.code_block &&
      doc.child(i - 1).type === schema.nodes.code_block
    )
      return true;
  }
  return false;
}

export function codeBlockMergePlugin() {
  return new Plugin({
    appendTransaction(_trs, _oldState, newState) {
      if (!hasAdjacentCodeBlocks(newState.doc)) return null;

      // Determine if the cursor is in the second block of an adjacent pair.
      // This decides which side of the inserted \n the cursor should land on.
      const $from = newState.doc.resolve(newState.selection.from);
      const blockIndex = $from.index(0);
      const cursorInSecondBlock =
        blockIndex > 0 &&
        newState.doc.child(blockIndex).type === schema.nodes.code_block &&
        newState.doc.child(blockIndex - 1).type === schema.nodes.code_block;

      const tr = newState.tr;
      mergeAdjacentCodeBlocks(tr);
      if (!tr.steps.length) return null;

      // Bias +1 places cursor after the \n;
      // bias -1 places it before.
      const bias = cursorInSecondBlock ? 1 : -1;
      const mappedPos = tr.mapping.map(newState.selection.from, bias);
      tr.setSelection(TextSelection.create(tr.doc, mappedPos));
      return tr;
    },
  });
}
